import { StudyGrid } from './StudyGrid.jsx';
import { MiniHeader, SiteFooter } from './site.jsx';

export default function StudiesPage() {
  return (
    <div className="landing">
      <MiniHeader />
      <main className="container studies-page">
        <p className="eyebrow">KAPstat studies</p>
        <h1 className="page-title">Pick a study, or share its link</h1>
        <p className="page-sub">Tap a study to take it. Use <b>Copy link</b> to hand a study to participants — each link opens that study directly, anonymously, on any phone.</p>
        <StudyGrid />
      </main>
      <SiteFooter />
    </div>
  );
}
